export default __webpack_public_path__ + "static/media/Angular_JsonServer_Todo_Listing.23b960b3.png";